var exports = {
  "kL": "x234b8571--115a64--container",
  "Sl": "x234b8571--115a64--image",
  "h_": "x234b8571--115a64--description",
};

module.exports = exports;
